export enum RedirectStatusMessageText {
	HEADING = 'Opening the app...',
	DESCRIPTION = 'Attempting to open the Niche Engage app...',
	FAILED_HEADING = "Couldn't open app",
	FAILED_DESCRIPTION = "If you weren't redirected, you might not have the app installed on your device or it didn't work. Please download the app using the button below.",
	DESKTOP_HEADING = 'It seems like you are not on a mobile device',
	DESKTOP_DESCRIPTION = 'Please open this email link on your mobile device to continue. Or feel free to open the app directly if you already have it installed.',
}
